import React from 'react';
import PropTypes from 'prop-types';
import Row from '../../shared/components/Row';
import Card from '../../shared/components/Card';
import HeaderSearchRefreshFilterOptions from '../../shared/components/HeaderSearchRefreshFilterOptions';
import { I18nUtils } from '../../../i18n/I18nUtils';
import CardSimpleHeader from '../../shared/components/CardSimpleHeader';
import CardBody from '../../shared/components/CardBody';
import OutsourceChart from './OutsourceChart';
import OutsourceForm from './OutsourceForm';
import WorksAccordion from './WorksAccordion';
import { connect } from 'react-redux';
import * as outsourceActions from '../actions/outsourceActions';
import { bindActionCreators } from 'redux';
import DocumentStateLegendChart from './DocumentStateLegendChart';
import UserRole from '../../shared/model/UserRole';
import StateManager from '../../shared/utils/StateManager';
import Select from '../../shared/components/Select';
import { cleanOutsourceWorks } from '../actions/outsourceActions';

class OutsourceDetailCard extends React.Component {

    constructor(props) {
        super(props);
        this.onRefresh = this.onRefresh.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.state = {
            loading: false,
            workPresenceTypeId: -1,
            workLevelTypeId: -1,
        };
    }

    componentWillMount() {
        this.getCompany();
    }

    componentWillUnmount() {
        this.props.outsourceActions.cleanOutsourceWorks();
    }

    onRefresh() {
        this.getCompany();
    }

    getCompany() {
        const {
            outsourceActions,
            outsourceId,
        } = this.props;
        outsourceActions.getCompany(outsourceId);
    }

    getCompanyWorks(selectedWorkPresenceTypeId, selectedWorkLevelTypeId) {
        const {
            outsourceActions,
            outsourceId,
        } = this.props;

        outsourceActions.getCompanyWorks(
            outsourceId,
            selectedWorkPresenceTypeId,
            selectedWorkLevelTypeId,
        );
    }

    onSubmit(values) {
        this.props.outsourceActions.updateCompany(values);
    }

    handleChangeWorkPresenceTypeId = (event) => {
        const { workLevelTypeId } = this.state;
        const value = parseInt(event.target.value);

        this.setState({ workPresenceTypeId: value });
        this.getCompanyWorks(value, workLevelTypeId);
    };

    handleChangeWorkLevelTypeId = (event) => {
        const { workPresenceTypeId } = this.state;
        const value = parseInt(event.target.value);

        this.setState({ workLevelTypeId: value });
        this.getCompanyWorks(workPresenceTypeId, value);
    };

    renderHeaderOptions() {
        const moreOptions = [];
        if ( this.props.user && this.props.user.roles && this.props.user.roles[0] ) {
            moreOptions.push({
                title: I18nUtils.tr('TR_EXPORTAR_DOCUMENTACION'),
                onClick: () => {
                    StateManager.clearExportDocs(); // Limpiamos los filtros antes de acceder
                    this.props.outsourceActions.goToExportDocs(this.props.outsourceId);
                },
            });
        }
        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                enableFilter={false}
                enableRefresh={true}
                enableSearch={false}
                moreOptions={moreOptions}
                cardSearchFilterEnabled={false}
            />
        );
    }

    renderSelectPresenceWork() {
        const {workPresenceTypeId} = this.state;

        return (
            <div className={"m-b-25"}>
                <label>{I18nUtils.tr('TR_PRESENCIA_EN_OBRA')}</label>
                <Select
                    className={"form-control show-tick bootstrap-select m-b-25"}
                    options={[
                        { value: 1, name: I18nUtils.tr('TR_ULTIMOS_DOCE_MESES') },
                        { value: 2, name: I18nUtils.tr('TR_ULTIMOS_SEIS_MESES') },
                        { value: 3, name: I18nUtils.tr('TR_ULTIMOS_TRES_MESES') },
                        { value: 4, name: I18nUtils.tr('TR_CON_O_SIN_PRESENCIA') },
                    ]}
                    value={workPresenceTypeId}
                    onChange={this.handleChangeWorkPresenceTypeId}
                    disabled={false}
                />
            </div>
        );
    }

    renderSelectLevelWork() {
        const {workLevelTypeId} = this.state;

        return (
            <div className={"m-b-25"}>
                <label>{I18nUtils.tr('TR_NIVEL')}</label>
                <Select
                    className={"form-control show-tick bootstrap-select"}
                    options={[
                        { value: 1, name: I18nUtils.tr('TR_TODOS_LOS_NIVELES') },
                        { value: 2, name: I18nUtils.tr('TR_PRIMER_NIVEL') },
                        { value: 3, name: I18nUtils.tr('TR_SEGUNDO_Y_SIGUIENTES') },
                    ]}
                    value={workLevelTypeId}
                    onChange={this.handleChangeWorkLevelTypeId}
                    disabled={false}
                />
            </div>
        );
    }

    render() {
        const {
            outsource,
            user,
            loading,
            outsourceWorks,
        } = this.props;
        let documentStats = [];
        let responsables = [];
        let users = [];
        if ( outsource ) {
            documentStats = outsource.document_stats;
            responsables = outsource.admins || [];
            users = outsource.users || [];
        }

        if ( !user || !user.roles || !user.roles[0] ) {
            return null;
        }
        const roleId = user.roles[0].role.id;

        const editable = roleId !== UserRole.OUTSOURCES_VIEWER;
        const allowChangeStatus = editable && roleId !== UserRole.OUTSOURCES_MANAGER;
        const isLoading = loading || this.state.loading;


        const noSelectedFilters = this.state.workLevelTypeId === -1 && this.state.workPresenceTypeId === -1;
        const noWorks = !isLoading &&
            (this.state.workLevelTypeId !== -1 || this.state.workPresenceTypeId !== -1 ) &&
            outsourceWorks && outsourceWorks.length === 0;

        return (
            <Row>
                <Card loading={isLoading}>
                    <CardSimpleHeader
                        title={I18nUtils.tr('TR_FICHA_SUBCONTRATA')}
                        options={this.renderHeaderOptions()}
                    />
                    <CardBody>
                        <Row>
                            <div className="col-md-8 col-lg-9">
                                <div className="row flex-card">
                                    <div className="col-xs-4 col-sm-3 flex-card-chart">
                                        <OutsourceChart stats={documentStats}/>
                                        <DocumentStateLegendChart/>
                                    </div>
                                    <div className="col-xs-8 col-sm-9 detail-text">
                                        <OutsourceForm
                                            onSubmit={this.onSubmit}
                                            outsource={outsource}
                                            editable={editable}
                                            showAllFields={true}
                                            allowChangeStatus={allowChangeStatus}
                                            changeLoading={this.changeLoading}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-lg-3 work-tree-list">
                                <h3>{I18nUtils.tr('TR_OBRAS')}</h3>
                                {this.renderSelectPresenceWork()}
                                {this.renderSelectLevelWork()}
                                <WorksAccordion
                                    works={outsourceWorks}
                                    allowNavigateToWork={roleId !== UserRole.OUTSOURCES_VIEWER}
                                />
                                {
                                    noSelectedFilters &&
                                    <h4 className={'text-center'}>
                                        {I18nUtils.tr('TR_SELECCIONE_LOS_PARAMETROS_DE_BUSQUEDA')}
                                    </h4>
                                }
                                {
                                    noWorks &&
                                    <h4 className={'text-center'}>
                                        {I18nUtils.tr('TR_NO_EXISTEN_OBRAS')}
                                    </h4>
                                }
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <hr/>
                                <div className="admin-subcontrata">
                                    <div>
                                        <h5>
                                            {I18nUtils.tr('TR_RESPONSABLES')}:
                                            {
                                                responsables.map((item, index) => (
                                                    <span
                                                        className="label bg-blue-grey"
                                                        style={{ marginLeft: '5px' }}
                                                        key={index}
                                                        children={item.name + ' ' + item.last_name}
                                                    />
                                                ))
                                            }
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </Row>
                        <Row>
                            <div className="col-sm-12">
                                <div className="admin-subcontrata">
                                    <div>
                                        <h5>
                                            {I18nUtils.tr('TR_USUARIOS')}:
                                            {
                                                users.map((item, index) => (
                                                    <span
                                                        className="label bg-blue-grey"
                                                        style={{ marginLeft: '5px' }}
                                                        key={index}
                                                        children={item.email}
                                                    />
                                                ))
                                            }
                                        </h5>
                                    </div>
                                </div>
                            </div>
                        </Row>
                    </CardBody>
                </Card>
            </Row>
        );
    }

    changeLoading = (loading) => {
        this.setState({ loading });
    };
}

const mapStateToProps = (state, ownProps) => {
    const {
        outsources,
        outsourceLoading,
        outsourceWorks,
        outsourceWorksLoading,
    } = state.outsources;

    return {
        outsource: outsources[ownProps.outsourceId],
        loading: outsourceLoading || outsourceWorksLoading,
        outsourceWorks: outsourceWorks,
        user: state.auth.user,
    };
};

const mapDispatchToProps = dispatch => ( {
    outsourceActions: bindActionCreators(outsourceActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(OutsourceDetailCard);

OutsourceDetailCard.propTypes = {
    outsourceId: PropTypes.string.isRequired,
};

OutsourceDetailCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/outsource/components/OutsourceDetailCard.js